import { render, staticRenderFns } from "./Menopause.vue?vue&type=template&id=6b60b7c2&"
import script from "./Menopause.vue?vue&type=script&lang=js&"
export * from "./Menopause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports